import ColorItem from './ColorItem.component';

export default ColorItem;
